<template>
  <div class="container" v-if="evaluatorDataLoaded && tagDataLoaded">
    <h4 class="title is-4">Evaluators with tag "{{ tag.name }}"</h4>
    <table class="table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Tags</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="evaluator in evaluators" :key="evaluator.id">
          <td>
            <router-link :to="{ name: 'EvaluatorDetail', params: { evaluatorId: evaluator.id } }">
              {{ evaluator.fullName }}
            </router-link>
          </td>
          <td>
            <span
              style="margin: .25rem"
              class="tag"
              v-for="evaluatorTag in evaluator.tagsRef"
              :key="evaluatorTag.id"
              @click="refreshPageNewTag(evaluatorTag.id)"
            >
              {{ evaluatorTag.name }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import store from '@/vuex/store'
import User from '@/services/users'
import Tag from '@/services/tags'

export default {
  data() {
    return {
      tag: {},
      evaluators: [],
      tagDataLoaded: false,
      evaluatorDataLoaded: false,
      evaluatorFilters: {
        isEvaluator: true,
        tags: [],
      },
      tagId: null,
    }
  },
  created() {
    this.tagId = this.$route.params.tagId
    this.evaluatorFilters.tags = []
    this.evaluatorFilters.tags.push(this.$route.params.tagId)
    this.refreshData()
  },
  methods: {
    refreshPageNewTag(tagId) {
      this.evaluatorFilters.tags = []
      this.evaluatorFilters.tags.push(tagId)
      this.tagId = tagId
      this.refreshData()
    },
    refreshData() {
      this.tagDataLoaded = false
      this.evaluatorDataLoaded = false

      Tag.api.get(this.tagId).then(response => {
        this.tag = response
        this.tagDataLoaded = true
      })

      User.api.list({ filters: this.evaluatorFilters }).then(data => {
        this.evaluators = data.results
        this.evaluatorDataLoaded = true
      })
    },
    updateEvaluator(evaluator, approvalStatus) {
      let newEvaluator = User.create(evaluator)
      newEvaluator.pendingAsEvaluator = !approvalStatus
      const fields = ['pendingAsEvaluator']
      User.api.update(newEvaluator, fields).then(() => {
        this.refreshData()
      })
    },
  },
}
</script>

<style scoped>
.tag {
  margin: 0 10px;
  cursor: pointer;
}
</style>
